// extracted by mini-css-extract-plugin
export default {"image":"styles_image__WVOrj","imagePendingWrapper":"styles_imagePendingWrapper__iiTq4","imageLoader":"styles_imageLoader__CqVjs"};